const EMAIL_REGEXP = /^(?!.*\.@|.*\.{2})[a-zA-Z0-9-]+[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]*@[a-zA-Z0-9-]+\.+([a-zA-Z0-9-]{2,})+(\.+([a-zA-Z0-9-]{2,})+)*$/;

const MOBILE_REGEXP = /(^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$)/;

const REDIRECT_MOBILE_REGEXP = /(^(\+44\s?7\d{3}|\(?07\d{3}\)?|7\d{3})\s?\d{3}\s?\d{3}$)/;

export default class RegularExpressions {
  static get email() {
    return EMAIL_REGEXP;
  }

  static get mobile() {
    return MOBILE_REGEXP;
  }

  static get redirectMobile() {
    return REDIRECT_MOBILE_REGEXP;
  }
}
